import Link from "next/link";
import Image from "next/image";

const FeaturedCasestudy = props => {
    let homeItems = props.how.map((item, index) => {
        return (
            <Link key={index} href={props.path + item.slug} passHref>
                <div className="group hover:shadow-md border border-transparent hover:border-indigo-100 cursor-pointer">
                    <div
                        className="flex flex-col text-start p-6 border border-indigo-100 group-hover:border-transparent">
                        <div className="">
                            <Image
                                alt={item.title}
                                src={
                                    item.feature_image
                                        ? item.feature_image
                                        : "/images/rectangle3.jpg"
                                }
                                width="264"
                                height="196"
                                layout="responsive"
                                objectFit="cover"
                                loading="lazy"
                            />
                        </div>
                        <div className="flex flex-1 mt-4 mb-6 overflow-hidden">
                            <p className="font-headline text-2xl font-semibold">
                                {item.title}
                            </p>
                        </div>
                        <div
                            className="font-body h-36 overflow-hidden text-base text-ellipsis text-gray-600 mb-2"
                            dangerouslySetInnerHTML={{__html: item.excerpt}}
                        ></div>
                        <div className="flex flex-auto"></div>
                        <div className="flex flex-initial justify-end md:hidden">
                            <Link href={props.path + item.slug} className="">
                                <button
                                    className="flex font-body text-sm font-extrabold text-blue-500 p-4 outline outline-0 focus:outline-0">
                                    {props.title}
                                </button>
                            </Link>
                        </div>
                    </div>

                    <div className="opacity-0 group-hover:opacity-100 p-6 hidden md:block items-end group ">
                        <div className="flex w-full justify-end">
                            <Link
                                href={props.path + item.slug}
                                className="flex w-full justify-end"
                            >
                                <button
                                    className="text-right flex font-body text-sm font-extrabold text-blue-500 outline outline-0 focus:outline-0">
                                    {props.title}
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
            </Link>
        );
    });
    return (
        <div className="grid grid-cols-1 md:grid-rows-1 md:grid-cols-3 gap-6">
            {homeItems}
        </div>
    );
};
export default FeaturedCasestudy;
